var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tags-list',_vm._b({model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'tags-list',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }